import axios from '@/helpers/axios'

export const fetchMedia = (params) =>
  axios.get('/api/media', { params })

export const uploadMedia = (formData) =>
  axios.post('/api/media', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })

export const updateMedia = (id, payload) =>
  axios.post(`/api/media/${id}`, payload)

export const deleteMedia = (id) =>
  axios.delete(`/api/media/${id}`)

export const attachMedia = (payload) =>
  axios.post('/api/media/attach', payload)